// ! TODO change for journey map requirements

import React, { Component } from 'react';
import * as d3 from 'd3';

import { Dimmer, Loader } from 'semantic-ui-react';

const angularCoeff = (val, tValMin, tValMax, tOtherValMin, tOtherValMax) =>
  ((tOtherValMax - tOtherValMin) / (tValMax - tValMin)) * (val - tValMin) + tOtherValMin;

class JourneyMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRendering: false,
      isFirstRender: true
    };
  }

  componentDidMount() {
    this.drawChart();
  }

  componentDidUpdate() {
    this.drawChart();
  }

  drawChart() {
    if (!this.props.journeyMap || !this.props.journeyMap.canItBeRender) {
      if (!this.state.isFirstRender) this.setState({ isFirstRender: true });
      return;
    }

    // console.log("As props", this.props.journeyMap)

    const svgInfos = {
      svg: null,
      wContainer: 800,
      hContainer: 550,
      wPadding: 60,
      hPadding: 70,
      w: null,
      h: null,
      horizontalLines: this.props.horizontalLines,
      verticalLines: 14,
      xInsetPadding: (this.props.journeyMap.xRange / 100) * 7,
      yInsetPadding: (this.props.journeyMap.yRange / 100) * 10
    };

    svgInfos.w = svgInfos.wContainer - svgInfos.wPadding * 2;
    svgInfos.h = svgInfos.hContainer - svgInfos.hPadding * 2;

    svgInfos.svg = d3
      .select(this.refs.journeyMapChart) // eslint-disable-line react/no-string-refs
      .attr('width', svgInfos.wContainer)
      .attr('height', svgInfos.hContainer);

    this.generateAxis(svgInfos);
    this.generateDots(svgInfos);
    this.generateText(svgInfos);

    if (this.state.isFirstRender) {
      this.setState({
        isFirstRender: false
      });
    }
  }

  generateText(svgInfos) {
    if (this.state.isFirstRender) {
      // Time (BOTTOM text)
      if (this.props.type !== 'aggregate') {
        svgInfos.svg
          .append('text')
          .text('Time (sec.)')
          .attr('class', 'x text');
      }

      // Activation (LEFT Text)
      svgInfos.svg
        .append('svg')
        .attr('class', 'y text')
        .attr('style', 'overflow:visible')
        .append('text')
        .text('Arousal')
        .attr('text-anchor', 'middle')
        .attr('transform', `rotate(-90)`);

      // Activation (TOP Text)
      if (this.props.titleTop) {
        svgInfos.svg
          .append('svg')
          .attr('class', 'top text')
          .attr('style', 'overflow:visible')
          .append('text')
          .text(this.props.titleTop)
          .attr('text-anchor', 'middle');
      }

      // Activation (TOP Text)
      if (this.props.type === 'aggregate') {
        const eventText = svgInfos.svg.selectAll('.event.text').data(this.props.journeyMap.data);

        const eventTextCalcX = d => d.x * (svgInfos.wContainer / (svgInfos.horizontalLines + 1));
        const eventTextCalcY = svgInfos.hContainer - svgInfos.hPadding / 2;

        eventText.exit().remove();

        eventText
          .enter()
          .append('svg')
          .attr('class', 'event text')
          .attr('style', 'overflow:visible')
          .attr('x', eventTextCalcX)
          .attr('y', eventTextCalcY)
          .append('text')
          .text(d => d.eventName)
          .attr('text-anchor', 'middle');

        eventText
          .transition()
          .duration(500)
          .attr('class', 'event text')
          .attr('style', 'overflow:visible')
          .attr('x', eventTextCalcX)
          .attr('y', eventTextCalcY);
      }
    }

    svgInfos.svg
      .selectAll('.x.text')
      .attr('x', svgInfos.wContainer / 2 - svgInfos.wPadding / 2)
      .attr('y', svgInfos.hContainer - svgInfos.hPadding / 5);

    svgInfos.svg
      .selectAll('.y.text')
      .attr('x', svgInfos.wPadding / 5)
      .attr('y', svgInfos.hContainer / 2 - svgInfos.hPadding / 2);

    svgInfos.svg
      .selectAll('.top.text')
      .attr('x', svgInfos.wContainer / 2)
      .attr('y', svgInfos.hPadding / 2 + 5);
  }

  calcRgbColor(d) {
    return `rgb(
      ${angularCoeff(
        d.intensity,
        this.props.journeyMap.minIntensity,
        this.props.journeyMap.maxIntensity,
        this.props.journeyMap.colorMin.r,
        this.props.journeyMap.colorMax.r
      )},
      ${angularCoeff(
        d.intensity,
        this.props.journeyMap.minIntensity,
        this.props.journeyMap.maxIntensity,
        this.props.journeyMap.colorMin.g,
        this.props.journeyMap.colorMax.g
      )},
      ${angularCoeff(
        d.intensity,
        this.props.journeyMap.minIntensity,
        this.props.journeyMap.maxIntensity,
        this.props.journeyMap.colorMin.b,
        this.props.journeyMap.colorMax.b
      )}
    )`;
  }

  generateDots(svgInfos) {
    const circle = svgInfos.svg.selectAll('circle').data(this.props.journeyMap.data);

    circle.exit().remove();

    let cxCalc = d =>
      (d.x * svgInfos.w) /
        (this.props.journeyMap.maxX + svgInfos.xInsetPadding - this.props.journeyMap.minX) +
      svgInfos.wPadding;

    if (this.props.journeyMap.minX === this.props.journeyMap.maxX)
      cxCalc = () => svgInfos.w / 2 + svgInfos.wPadding;

    if (this.props.type === 'aggregate')
      cxCalc = d =>
        d.x * (svgInfos.w / svgInfos.horizontalLines) +
        svgInfos.wPadding -
        svgInfos.w / svgInfos.horizontalLines / 2;

    let cyCalc = d =>
      -(
        ((d.y - this.props.journeyMap.minY) * svgInfos.h) /
        (this.props.journeyMap.maxY - this.props.journeyMap.minY + svgInfos.yInsetPadding)
      ) +
      svgInfos.hPadding +
      svgInfos.h;
    if (this.props.journeyMap.minY === this.props.journeyMap.maxY)
      cyCalc = () => svgInfos.h / 2 + svgInfos.hPadding;

    circle
      .enter()
      .append('circle')
      .transition()
      .duration(500)
      .attr('cx', cxCalc)
      .attr('cy', cyCalc)
      .attr('r', (d, i) =>
        angularCoeff(
          d.size,
          this.props.journeyMap.minSize,
          this.props.journeyMap.maxSize,
          this.props.journeyMap.minSizeRadius,
          this.props.journeyMap.maxSizeRadius
        )
      )
      .attr('stroke', (d, i) => this.calcRgbColor(d))
      .attr('stroke-width', 2.5)
      .attr('fill', this.props.dotColorBorderOnly ? 'transparent' : (d, i) => this.calcRgbColor(d));

    circle
      .transition()
      .duration(500)
      .attr('cx', cxCalc)
      .attr('cy', cyCalc)
      .attr('r', (d, i) =>
        angularCoeff(
          d.size,
          this.props.journeyMap.minSize,
          this.props.journeyMap.maxSize,
          this.props.journeyMap.minSizeRadius,
          this.props.journeyMap.maxSizeRadius
        )
      )
      .attr('stroke', (d, i) => this.calcRgbColor(d))
      .attr('stroke-width', 2.5)
      .attr('fill', this.props.dotColorBorderOnly ? 'transparent' : (d, i) => this.calcRgbColor(d));
  }

  generateAxis(svgInfos) {
    /*
     * Domain defin de range of values (Min & Max) display
     * Range is about the render size view
     */
    const xAisScale = d3
      .scaleLinear()
      .domain([this.props.journeyMap.minX, this.props.journeyMap.maxX]) // Data show
      .range([0, svgInfos.w]); // View size

    const yAxisScale = d3
      .scaleLinear()
      .domain([this.props.journeyMap.maxY + svgInfos.yInsetPadding, this.props.journeyMap.minY]) // Data show
      .range([0, svgInfos.h]); // View size

    let xAxis;
    let xPosition;
    let xGridPosition;
    if (this.props.xAxisPosition === 'bottom') {
      xAxis = d3.axisBottom(xAisScale).ticks(svgInfos.horizontalLines);
      xPosition = svgInfos.h + svgInfos.hPadding;
      xGridPosition = svgInfos.hPadding;
    }

    if (this.props.xAxisPosition === 'top') {
      xAxis = d3.axisTop(xAisScale).ticks(svgInfos.horizontalLines);
      xPosition = 0 + svgInfos.hPadding;
      xGridPosition = svgInfos.h + svgInfos.hPadding;
    }

    const yAxis = d3.axisLeft(yAxisScale).ticks(svgInfos.verticalLines);

    if (this.state.isFirstRender) {
      // Main Axes (First)
      svgInfos.svg.append('g').attr('class', `x axis ${this.props.type}`);

      svgInfos.svg.append('g').attr('class', `y axis ${this.props.type}`);

      // Grid Axes
      svgInfos.svg.append('g').attr('class', `y grid ${this.props.type}`);

      svgInfos.svg.append('g').attr('class', `x grid ${this.props.type}`);
    }

    // Set main Axes
    svgInfos.svg
      .select('.x.axis')
      .transition()
      .attr(
        'transform',
        `translate(${svgInfos.wPadding + svgInfos.w / svgInfos.horizontalLines / 2}, ${xPosition})`
      )
      .call(xAxis);

    svgInfos.svg
      .select('.y.axis')
      .transition()
      .attr('transform', `translate(${svgInfos.wPadding}, ${svgInfos.hPadding})`)
      .call(yAxis);

    // Set Grid Axes
    svgInfos.svg
      .select('.x.grid')
      .transition()
      .call(xAxis.tickSize(svgInfos.h).tickFormat(''))
      .attr('transform', `translate(${svgInfos.wPadding}, ${xGridPosition})`);

    svgInfos.svg
      .select('.y.grid')
      .transition()
      .call(yAxis.tickSize(svgInfos.w).tickFormat(''))
      .attr('transform', `translate(${svgInfos.w + svgInfos.wPadding}, ${svgInfos.hPadding})`);

    return svgInfos;
  }

  render() {
    const congnitiveSize = [];
    const colorGradient = [];

    if (this.props.journeyMap && this.props.journeyMap.canItBeRender) {
      for (
        let size = this.props.journeyMap.minSize;
        size < this.props.journeyMap.maxSize;
        size += this.props.journeyMap.sizeStep
      ) {
        congnitiveSize.push(
          <div className="journeyMap__table-values journeyMap__table-cognitive" key={size}>
            <span className="journeyMap__table-cognitive-circle">
              <svg width="35" height="35">
                <circle
                  stroke="#B5B5B5"
                  strokeWidth="2"
                  fill="#D8D8D8"
                  cx="17.5"
                  cy="17.5"
                  r={angularCoeff(
                    size,
                    this.props.journeyMap.minSize,
                    this.props.journeyMap.maxSize,
                    this.props.journeyMap.minSizeRadius,
                    this.props.journeyMap.maxSizeRadius
                  )}
                />
              </svg>
            </span>
            <span className="journeyMap__table-cognitive-values">{size.toFixed(2)}</span>
          </div>
        );
      }
    }

    let leftPosition = 0;
    if (this.props.journeyMap && this.props.journeyMap.canItBeRender) {
      for (
        let intensity = this.props.journeyMap.minIntensity;
        intensity < this.props.journeyMap.maxIntensity;
        intensity += this.props.journeyMap.intensityStep
      ) {
        const rgbColor = `rgb(
          ${angularCoeff(
            intensity,
            this.props.journeyMap.minIntensity,
            this.props.journeyMap.maxIntensity,
            this.props.journeyMap.colorMin.r,
            this.props.journeyMap.colorMax.r
          )},
          ${angularCoeff(
            intensity,
            this.props.journeyMap.minIntensity,
            this.props.journeyMap.maxIntensity,
            this.props.journeyMap.colorMin.g,
            this.props.journeyMap.colorMax.g
          )},
          ${angularCoeff(
            intensity,
            this.props.journeyMap.minIntensity,
            this.props.journeyMap.maxIntensity,
            this.props.journeyMap.colorMin.b,
            this.props.journeyMap.colorMax.b
          )}
        )`;

        colorGradient.push(
          <rect
            x={leftPosition}
            fill={rgbColor}
            width="35"
            height="35"
            stroke="#000"
            strokeWidth="0.25"
            key={intensity}
          />
        );

        leftPosition += 20;
      }
    }

    let elementToShow = [];
    const participantHtml = [
      this.props.participant ? (
        <div className="journeyMap__table journeyMap__table-participant" key="whatever">
          <h5 className="journeyMap__table-title">Participant:</h5>
          <div className="journeyMap__table-values journeyMap__table-cognitive">
            {this.props.journeyMap.participantId}
          </div>
        </div>
      ) : (
        ''
      )
    ];

    if (this.props.journeyMap && this.props.journeyMap.canItBeRender)
      elementToShow = [
        <div key="whatever2">
          {participantHtml}
          <div className="journeyMap__table">
            <h5 className="journeyMap__table-title">Cognitive load:</h5>
            {congnitiveSize}
          </div>
          <div className="journeyMap__table journeyMap__table--valence">
            <h5 className="journeyMap__table-title journeyMap__table-title--valence">Valence:</h5>

            <div className="journeyMap__table-values journeyMap__table-gradient-min-max">
              <svg width="auto" height="25">
                {colorGradient}
              </svg>
              <span className="journeyMap__table-values journeyMap__table-gradient-val journeyMap__table-values journeyMap__table-gradient-min">
                {this.props.journeyMap.minIntensity.toFixed(2)}
              </span>
              <span className="journeyMap__table-values journeyMap__table-gradient-val journeyMap__table-values journeyMap__table-gradient-max">
                {this.props.journeyMap.maxIntensity.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      ];

    return (
      <Dimmer.Dimmable>
        <Dimmer active={this.state.isRendering} inverted>
          <Loader size="huge">Generating Journey Map</Loader>
        </Dimmer>

        {elementToShow}

        {this.props.journeyMap && this.props.journeyMap.canItBeRender ? (
          <svg className={`journeyMap ${this.props.type}`} ref="journeyMapChart" /> // eslint-disable-line react/no-string-refs
        ) : (
          <h5 style={{ textAlign: 'center' }}>No data</h5>
        )}

        {this.props.journeyMap && this.props.journeyMap.dataError ? (
          <p style={{ textAlign: 'center' }}>No data has been fetch or an error has occur</p>
        ) : (
          ''
        )}

        {this.props.journeyMap && this.props.journeyMap.keyNameError ? (
          <p style={{ textAlign: 'center' }}>A key name in the data is missing</p>
        ) : (
          ''
        )}
      </Dimmer.Dimmable>
    );
  }
}

JourneyMap.defaultProps = {
  horizontalLines: 16,
  participant: true,
  dotColorBorderOnly: true,
  type: 'participant',
  xAxisPosition: 'bottom',
  titleTop: null
};

export default JourneyMap;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/JourneyMap.js